import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import moment from "moment"
import 'moment/locale/es';
import { useAlert } from "react-alert";

export default function News() {
    let alert = useAlert();
    const [newsdata, setnewsdata] = useState([]);

    useEffect(() => {
        getNews()
    }, [])

    const getNews = () => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getNews?limit=4`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setnewsdata(data);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener las noticias", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    return (
        <div>
            <div className="container">
                <h2 className='fw-bold fst-italic colorpurple'>Noticias OIC</h2>
            </div>
            <img src="linea-de-color.jpg" alt='Linea Color' className='img-fluidLine reverse' style={{ marginBottom: "-17px" }} />
            <div className="backgroundpurple p-2">
                <div className="newsContainer">
                    {newsdata.map((news, index) => {
                        return <Link key={index} to={`/newsdetail/${news.info.uuid}`} className='noLink newsCenter'>
                            <div className="newchild text-center">
                                <div className="card-body">
                                    <div className="text-center">
                                        {news.images.length > 0 &&
                                            <img src={news.images[0].preview} alt="" style={{ width: 300, height: 250 }} />
                                        }
                                    </div>
                                    <p className='pt-2'><h4>{news.info.title}</h4></p>
                                    <p>{moment(news.info.createdAt).format("LL")}</p>
                                </div>
                            </div>
                        </Link>
                    })}
                </div>
                <div className="text-center pt-2">
                    <Link className='noLink' style={{ color: "white" }} to={"/news"}><h4>Leer más noticias</h4></Link>
                </div>
            </div>
        </div >
    )
}
